import * as React from 'react';
import { trackClickLayout, trackClickPhotos, trackClickVideo } from '../tracking';
import * as styles from './index.css';
import { MenuButton } from './menu_button';

export interface IControlsProps {
  isVideo: boolean | undefined;
  photoCount: number | undefined;
  layoutId: number | undefined;
  isVideoPlay: boolean;
  isFloorPlan: boolean;
  isSingleGalleryCount: boolean;
  isInitialized: boolean;

  onElementShow(id: number): void;
  openMvkWidget(): void;
}

export class Controls extends React.Component<IControlsProps, {}> {
  public render() {

    if (!this.props.isInitialized) {
      return null;
    }

    const className = this.props.isVideoPlay ? 'controls--hidden' : 'controls';

    return (
      <div className={getClassNameWithPosition(styles[className], styles['single'], this.props.isSingleGalleryCount)}>
        {this.props.isVideo &&
          <MenuButton type="video"
            elementsCount={1}
            id={0}
            onButtonClick={(id: number) => {
              trackClickVideo();
              this.props.onElementShow(id);
            }}
          />}
        {this.props.layoutId !== undefined &&
          <MenuButton type="layout"
            elementsCount={1}
            id={getLayoutId(this.props.isVideo, this.props.layoutId)}
            onButtonClick={(id: number) => {
              trackClickLayout();
              this.props.onElementShow(id);
            }}
          />}
        {this.props.photoCount !== undefined &&
          <MenuButton type="photo"
            elementsCount={this.props.photoCount}
            id={getFirstPhotoId(this.props.isVideo)}
            onButtonClick={(id: number) => {
              trackClickPhotos();
              this.props.onElementShow(id);
            }}
          />}
        {this.props.isFloorPlan &&
          <MenuButton type="floor-plan"
            elementsCount={0}
            id={0}
            onButtonClick={this.props.openMvkWidget}
          />}
      </div>
    );
  }
}

function getFirstPhotoId(isVideo: boolean | undefined) {
  return isVideo ? 1 : 0;
}

function getLayoutId(isVideo: boolean | undefined, id: number) {
  return isVideo ? id + 1 : id;
}

function getClassNameWithPosition(name: string, optionName: string, isSingle: boolean) {
  return isSingle ? `${name} ${optionName}` : name;
}
